import { ReactNode } from 'react'
import { FlexColumn } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'

type Props = {
  label: string
  children: ReactNode
}

export default function FieldView({ label, children }: Props) {
  return (
    <FlexColumn space={0} wrap scroll={false}>
      <Label text={label} variant="caption" />
      {children}
    </FlexColumn>
  )
}
